import { ReactNode, isValidElement } from "react";
import React from "react";
import "./styles.css";
import {
  ListItem,
  ListItemIcon,
  Menu,
  Icon,
  IconName,
  IconProps,
  Tooltip,
  IconButton,
  Text,
  useMediaQuery,
} from "@techzyapp/ui-lib";

export interface TableActionsProps {
  children?: ReactNode;
}
const TableActions = ({ children }: TableActionsProps) => {
  const xs = useMediaQuery("xs");
  const childrenCount = React.Children.count(children);
  const dynamicItems =
    children &&
    React.Children.map(children, (child, index) => {
      if (isValidElement(child)) {
        const childProps = child.props as {
          iconName?: IconName;
          color?: IconProps["color"];
          label?: string;
          onClick?: () => void;
          disabled?: boolean;
          title?: string;
        };
        const isTooltip = child.type === Tooltip;
        const handleClick = isTooltip
          ? (child.props.children.props.onClick as () => void)
          : childProps.onClick;
        return {
          children: (
            <ListItem disablePadding onClick={handleClick}>
              <ListItemIcon>
                <Icon
                  name={
                    isTooltip
                      ? child.props.children.props.iconName
                      : childProps.iconName
                  }
                  color={
                    isTooltip
                      ? child.props.children.props.color
                      : childProps.color
                  }
                />
              </ListItemIcon>
              {isTooltip && child.props.title ? (
                <Text color="primary">{child.props.title}</Text>
              ) : (
                childProps.label && (
                  <Text color="primary">{childProps.label}</Text>
                )
              )}
            </ListItem>
          ),
          disabled:
            childProps.disabled ||
            (isTooltip ? child.props.children.props.disabled : undefined),
        };
      }
      return null;
    });
  if (xs && childrenCount > 1 && dynamicItems) {
    return (
      <Menu
        size="sm"
        component={
          <div className="MuiTableActions-more-btn">
            <IconButton iconName="More" />
          </div>
        }
        items={dynamicItems}
      />
    );
  }
  return <div className="MuiTableActions-wrapper">{children}</div>;
};
export default TableActions;
